import {ssrLazy} from 'ssr/lazy';

export const BoxContainerLazy = ssrLazy(() => import(/* webpackChunkName: "boxContainer" */ 'app/components/boxContainer'));
export const BoxContainerPBLazy = ssrLazy(() => import(/* webpackChunkName: "boxContainerPB" */ 'app/components/boxContainer/pb'));
